<template>
  <div class="project-approval-page">
    <!-- 页面标题 -->
    <div class="page-header">
      <div class="header-left">
        <i class="el-icon-s-order"></i>
        <h2>{{activeSubText}}</h2>
      </div>
    </div>

    <!-- 横向时间线分类区域 -->
    <div class="timeline-section">
      <div class="timeline-container">
        <div 
          v-for="(mainItem, mainIndex) in mainCategories" 
          :key="mainIndex"
          class="timeline-block"
          :style="{
            flex: mainItem.subs.length 
          }"
        >
          <!-- 大分类标题 -->
          <div class="main-category-header" :style="{ 
            backgroundColor: mainItem.color,
          }">
            <span class="main-name">{{ mainItem.name }}</span>
            <!-- <span class="main-count">{{ mainItem.count }}</span> -->
          </div>
          
          <!-- 二级分类 -->
          <div class="sub-categories">
            <div 
              v-for="(subItem, subIndex) in mainItem.subs" 
              :key="subIndex"
              :class="['sub-category-pill', { 
                active: activeSub === subItem.value 
              }]"
              @click="handleSubClick(subItem)"
            >
              {{ subItem.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <ExamineNotice v-if="activeSub == 'A1'"></ExamineNotice>
    <ApprovalNotice v-if="activeSub == 'A2'"></ApprovalNotice>
    <RecordPublic v-if="activeSub == 'A3'"></RecordPublic>
    <EiaReport v-if="activeSub == 'B1'"></EiaReport>
    <EnergyNotice v-if="activeSub == 'B2'"></EnergyNotice>
    <LandPreapproval v-if="activeSub == 'C1'"></LandPreapproval>
    <landSearch v-if="activeSub == 'C2'"></landSearch>
    <LandPermit v-if="activeSub == 'D1'"></LandPermit>
    <ConstructionPermit v-if="activeSub == 'D2'"></ConstructionPermit>
    <buildPermit v-if="activeSub == 'E2'"></buildPermit>
    <tenderingBidding v-if="activeSub == 'E1'"></tenderingBidding>
    <!-- <div v-if="activeSub == 'E1' || activeSub == 'E2'"> <el-empty description="即将上线"></el-empty> </div> -->
  </div>
</template>

<script>
import ExamineNotice from './ExamineNotice/index.vue' // 项目审批
import ApprovalNotice from './ApprovalNotice/index.vue' // 项目核准
import LandPreapproval from './LandPreapproval/index.vue' // 用地预审与选址意见
import LandPermit from './LandPermit/index.vue' // 用地规划许可
import RecordPublic from './RecordPublic/index.vue' // 项目备案
import ConstructionPermit from './ConstructionPermit/index.vue' // 工程规划许可
import EnergyNotice from './EnergyNotice/index.vue' // 节能审查
import landSearch from './landSearch/index.vue' // 项目拿地
import EiaReport from '@/views/dashboard/EiaReport/index.vue' // 环境评价
import buildPermit from './buildPermit/index.vue' // 建设工程许可
import tenderingBidding from './tenderingBidding/index.vue' //招投标

export default {
  name: 'ProjectApproval',
  components: {
    ExamineNotice,
    ApprovalNotice,
    LandPreapproval,
    LandPermit,
    RecordPublic,
    ConstructionPermit,
    EnergyNotice,
    landSearch,
    EiaReport,
    buildPermit,
    tenderingBidding
  },
  data() {
    return {
      // 主分类数据（带时间线颜色）
      mainCategories: [
        { 
          name: '立项', 
          value: 'A',
          color: '#e8f5e9', 
          fontColor: '#4caf50',
          count: 128, 
          subs: [
            { name: '项目备案', value: 'A3' },
            { name: '项目审批', value: 'A1' },
            { name: '项目核准', value: 'A2' },
          ] 
        },
        { 
          name: '专项审核', 
          value: 'B',
          color: '#e3f2fd', 
          fontColor: '#2196f3',
          count: 86, 
          subs: [
            { name: '环境评价', value: 'B1' },
            { name: '节能审查', value: 'B2' }
          ] 
        },
        { 
          name: '用地', 
          value: 'C',
          color: '#fff3e0', 
          fontColor: '#ff9800',
          count: 64, 
          subs: [
            { name: '用地预审与选址意见', value: 'C1' },
            { name: '项目拿地', value: 'C2' }
          ] 
        },
        { 
          name: '规划设计', 
          value: 'D',
          color: '#fce4ec', 
          fontColor: '#ff5722',
          count: 92, 
          subs: [
            { name: '用地规划许可', value: 'D1' },
            { name: '工程规划许可', value: 'D2' },
            // { name: '初步设计', value: 'D3' },
          ] 
        },
        { 
          name: '施工', 
          value: 'E',
          color: '#e5e5e5', 
          fontColor: '#595656',
          count: 156, 
          subs: [
            
            { name: '招投标', value: 'E1' },
            { name: '施工许可', value: 'E2' }
          ] 
        }
      ],
      activeMain: 4, // 默认选中"施工"
      activeSub: 'A3', // 默认选中"招投标"
      activeSubText: '项目审批',
      
      // 表格数据
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0
    }
  },

  mounted() {
    // this.fetchData()
  },
  
  methods: {
    // 二级分类点击
    handleSubClick(item) {
      this.activeSub = item.value;
      this.activeSubText = item.name;
    },
    // 表头样式
    headerCellStyle() {
      return {
        backgroundColor: '#2c5282',
        color: '#fff',
        fontWeight: 600,
        fontSize: '14px'
      }
    }, 
    
  }
}
</script>

<style lang="less" scoped>
.project-approval-page {
  padding: 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
  
  // 页面头部
  .page-header {
    margin-bottom: 20px;
    padding: 0 5px;
    
    .header-left {
      display: flex;
      align-items: center;
      
      i {
        font-size: 24px;
        color: #2c5282;
        margin-right: 10px;
      }
      
      h2 {
        font-size: 20px;
        font-weight: 600;
        color: #1a365d;
        margin: 0;
      }
    }
  }
  
  // 横向时间线分类区域
  .timeline-section {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    margin-bottom: 20px;
    overflow: hidden;
    
    .timeline-container {
      display: flex;
      width: 100%;
    }
    
    .timeline-block {
      display: flex;
      flex-direction: column;
      border-right: 1px solid rgba(0,0,0,0.08);
      min-height: 90px;
      
      &:last-child {
        border-right: none;
      }
      
      // 大分类标题
      .main-category-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 16px;
        border-bottom: 1px solid rgba(0,0,0,0.06);
        justify-content: space-around;
        .main-name {
          font-size: 14px;
          font-weight: 600;
          color: #1a365d;
        }
        
        .main-count {
          font-size: 12px;
          color: #4a5568;
          background: rgba(255,255,255,0.7);
          padding: 2px 8px;
          border-radius: 10px;
          min-width: 24px;
          text-align: center;
        }
      }
      
      // 二级分类容器
      .sub-categories {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        padding: 12px 16px;
        flex: 1;
        align-items: center;
        justify-content: space-around;
        
        // 二级分类胶囊
        .sub-category-pill {
          padding: 6px 14px;
          border-radius: 16px;
          font-size: 13px;
          color: #4a5568;
          background: #005aa817;
          border: 1px solid #e2e8f0;
          cursor: pointer;
          transition: all 0.25s ease;
          white-space: nowrap;
          box-shadow: 0 1px 2px rgba(0,0,0,0.04);
          
          &:hover {
            border-color: #2c5282;
            color: #2c5282;
            transform: translateY(-1px);
            box-shadow: 0 2px 6px rgba(44, 82, 130, 0.15);
          }
          
          // 选中状态 - 深蓝填充
          &.active {
            background: #2c5282 !important;
            border-color: #2c5282 !important;
            color: #fff !important;
            box-shadow: 0 2px 8px rgba(44, 82, 130, 0.3);
            font-weight: 500;
          }
        }
      }
    }
  }
  
  // 筛选区域
  .filter-section {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    
    .filter-row {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 20px;
    }
    
    .filter-item {
      display: flex;
      align-items: center;
      
      .filter-label {
        font-size: 14px;
        color: #4a5568;
        margin-right: 10px;
        font-weight: 500;
        white-space: nowrap;
      }
      
      &.search-item {
        flex: 1;
        max-width: 300px;
      }
    }
    
    .date-picker {
      width: 280px;
    }
    
    .location-picker {
      width: 200px;
    }
    
    .search-input {
      width: 100%;
    }
    
    .filter-actions {
      margin-left: auto;
      
      .el-button {
        margin-left: 10px;
      }
    }
  }
  
  // 表格区域
  .table-section {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    
    .table-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      
      .table-title {
        display: flex;
        align-items: center;
        
        i {
          font-size: 18px;
          color: #2c5282;
          margin-right: 8px;
        }
        
        span {
          font-size: 16px;
          font-weight: 600;
          color: #1a365d;
          margin-right: 10px;
        }
        
        .el-tag {
          font-weight: normal;
        }
      }
    }
    
    // 表格样式
    .data-table {
      border-radius: 6px;
      overflow: hidden;
      font-size: 16px;
      ::v-deep .el-table__header-wrapper {
        th {
          background-color: #2c5282 !important;
        }
      }
      
      .code-text {
        color: #4a5568;
        font-size: 16px;
        letter-spacing: 0.5px;
      }
      
      .status-dot {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-right: 6px;
        
        &.active {
          background: #48bb78;
          box-shadow: 0 0 0 2px rgba(72, 187, 120, 0.2);
        }
        
        &.inactive {
          background: #cbd5e0;
        }
      }
      
      .date-icon {
        color: #2c5282;
        margin-right: 4px;
      }
      
      ::v-deep .el-link {
        font-weight: 500;
      }
    }
    
    // 分页
    .pagination-wrapper {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
    }
  }
}

// 按钮主题色覆盖
::v-deep .el-button--primary {
  background: #2c5282;
  border-color: #2c5282;
  
  &:hover, &:focus {
    background: #1a365d;
    border-color: #1a365d;
  }
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #2c5282;
}

::v-deep .el-link.el-link--primary {
  color: #2c5282;
  
  &:hover {
    color: #1a365d;
  }
}
</style>